import { NumberInput } from '../../../baseInputs/NumberInput';

export const RadiusInput = ({
  value,
  onChange,
}: {
  value?: string;
  onChange: (newValue?: string | number) => void;
}) => {
  return (
    <NumberInput
      iconClassName="icon-radius"
      value={value}
      onChange={onChange}
      precision={0}
      minValue={0}
      percentMax={50}
      units={['px', '%']}
      defaultUnit="px"
      id="radius-input"
      tooltip="Corner Radius"
      style={{ maxWidth: '111px' }}
      inputStyle={{ textAlign: 'center' }}
    />
  );
};
